import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'
import type { TicketComment } from './easeedesk'

/**
 * Clopotelul de COLABORARE din antet (`#my_ticket_comments_btn`,
 * `#collaborate-badge-header`) - contractele lui
 * `EaseedeskTicketCommentsController`. Perechile vechi:
 *
 *   easeedesk/unread_comments_counter   -> GET /easeedesk/comments/unread/count
 *   easeedesk/myCommentsList            -> GET /easeedesk/comments/unread
 *   easeedesk/myTicketCommentsList/{id} -> GET /easeedesk/tickets/{id}/comments/unread
 *                                          + POST /easeedesk/tickets/{id}/comments/read
 *
 * Cheile de query incep toate cu `['easeedesk', 'collaborate']`, ca fila
 * Collaborate sa le poata invalida pe toate deodata dupa ce a marcat citite.
 */

export interface CollaborateTicket {
  ticket: number
  subject: string
  /** Cate comentarii necitite are tichetul. */
  count: number
  last: { id: number; comment: string; created: string } | null
}

export interface CollaborateTicketPage {
  ticket: number
  subject: string
  comments: TicketComment[]
}

/**
 * Insigna. In portal se cerea din minut in minut
 * (`resources/js/tasks/counters/Collaborate.js`, `timer`), si tot atat si aici.
 */
export const collaborateCountQuery = queryOptions({
  queryKey: ['easeedesk', 'collaborate', 'count'],
  queryFn: () => apiGet<{ count: number }>('/easeedesk/comments/unread/count'),
  refetchInterval: 60_000,
  staleTime: 30_000,
})

/** Lista tichetelor cu necitite, proaspata la fiecare deschidere. */
export const collaborateListQuery = queryOptions({
  queryKey: ['easeedesk', 'collaborate', 'list'],
  queryFn: () => apiGet<{ tickets: CollaborateTicket[] }>('/easeedesk/comments/unread'),
  staleTime: 0,
  gcTime: 0,
})

export function collaborateTicketQuery(id: number) {
  return queryOptions({
    queryKey: ['easeedesk', 'collaborate', 'ticket', id],
    queryFn: () => apiGet<CollaborateTicketPage>(`/easeedesk/tickets/${id}/comments/unread`),
    staleTime: 0,
    gcTime: 0,
  })
}

/** Marcarea ca citite a comentariilor unui tichet - partea de scriere a lui `myTicketCommentsList`. */
export function markCollaborateRead(id: number): Promise<{ status: string }> {
  return apiPost<{ status: string }>(`/easeedesk/tickets/${id}/comments/read`, {})
}
